import Screen from "../lib/Screen";

import * as PIXI from "pixi.js";
import gsap from "gsap";
import { IGameSnacks } from "../lib/GameSnacks";
import ServiceLocator from "../ServiceLocator";
import Utils from "../Utils";
import Button from "../lib/Button";
import { Profile } from "../lib/game_snacks/IUser";
import Session, { game_type } from "../Session";
import { Signal } from "signals";
import PRNG from "../lib/PRNG";
import PlayerSlot from "./popup/PlayerSlot";
import Settings from "./Settings";
import TutorialPopup from "./popup/TutorialPopup";
import { screen_type } from "../state/GameState";
import MatchmakingReadyAnim from "./popup/MatchmakingReadyAnim";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class FakeMatchMakingScreen extends Screen
{
    // #region Attributes //

    // private:

    private _matchmakingReadyAnim: MatchmakingReadyAnim = null;
    private _headerText: PIXI.Text = null;
    private _magnifyingGlass: PIXI.Sprite = null;
    private _arrPlayerSlot: Array<PlayerSlot> = null;
    private _settings: Settings = null;

    private _arrBotNames: Array<string> = null;
    private _arrBotAvatarIndex: Array<number> = null;

    private _autoStartTimer: number = null;

    private _magnifyingGlassTween: gsap.core.Tween = null;

    // #endregion //


    // #region Methods //

    // public:

    public onEnter(): void
    {
        super.onEnter();        

        this._arrPlayerSlot = [];

        this._arrBotNames = Utils.generateBotNames( Session.i.kGameRoomSize - 1 );
        //                
        this._arrBotAvatarIndex = [];
        while ( this._arrBotAvatarIndex.length < Session.i.kGameRoomSize - 1 )
        {
            const kBotAvatarIndex: number = Math.floor( Math.random() * 12 );
            if ( !this._arrBotAvatarIndex.includes( kBotAvatarIndex ) )
            {
                this._arrBotAvatarIndex.push( kBotAvatarIndex );
            }
        }

        let bg: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.bg.texture );
        bg.anchor.set( 0.5 );
        bg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( bg );
        
        this._matchmakingReadyAnim = new MatchmakingReadyAnim();
        this._matchmakingReadyAnim.playerSlots = this._arrPlayerSlot;
        this._matchmakingReadyAnim.init();
        this._root.addChild( this._matchmakingReadyAnim );
        this._matchmakingReadyAnim.visible = false;

        this._headerText = new PIXI.Text( "Searching for\nCrazy 8 players...", { fontFamily: "asap_bold", fontSize: 50, fill: 0xffffdf, align: "center" } );
        this._headerText.anchor.set( 0.5 );
        this._headerText.position.set( ServiceLocator.app.width * 0.5, 218 - 20 );
        this._root.addChild( this._headerText );

        const kArrPos: Array<PIXI.Point> = [ 
            new PIXI.Point( ServiceLocator.app.width * 0.5, 764 ),
            new PIXI.Point( 105, 550 ),
            new PIXI.Point( 526, 550 ),
            new PIXI.Point( ServiceLocator.app.width * 0.5, 354 ) ];
        for ( let i: number = 0; i < Session.i.kGameRoomSize; ++i )
        {
            let playerSlot: PlayerSlot = new PlayerSlot();
            playerSlot.position.copyFrom( kArrPos[ i ] );
            this._root.addChild( playerSlot );            
            //
            this._arrPlayerSlot.push( playerSlot );
        }
        this._arrPlayerSlot[ 0 ].setPlayer( Session.i.profile );
        this._arrPlayerSlot[ 0 ].scale.set( 1.2 );

        this._magnifyingGlass = new PIXI.Sprite( ServiceLocator.resources.magnifying_glass.texture );
        this._magnifyingGlass.anchor.set( 70/173, 68/206 );
        this._magnifyingGlass.position.set( ServiceLocator.app.width * 0.5 - 40, 577 );
        this._root.addChild( this._magnifyingGlass );
        //
        this._magnifyingGlassTween = gsap.to( {}, { duration: 2, repeat: -1, onUpdate: () => {
            let m: PIXI.Matrix = PIXI.Matrix.IDENTITY.clone();
            m.tx = -40;
            m.rotate( this._magnifyingGlassTween.progress() * Math.PI * 2 );
            
            this._magnifyingGlass.position.set( ServiceLocator.app.width * 0.5 + m.tx, 577 + m.ty );
        } } );

        this._settings = new Settings();
        this._settings.init( false );
        this._settings.position.set( ServiceLocator.app.width - 58, 58 );
        this._root.addChild( this._settings );
        this._settings.onTutorial.add( () => { 
            let tutorialPopup: TutorialPopup = new TutorialPopup();
            tutorialPopup.init();
            this._root.addChild( tutorialPopup );
            tutorialPopup.onClosed.add( ( popup: TutorialPopup ) => {
                popup.end();
            } );
        } );
        //
        const kSettingsScale: number = 100 / this._settings.width;
        this._settings.position.x -= 58 * ( kSettingsScale - 1 ); 
        this._settings.position.y += 58 * ( kSettingsScale - 1 ) - 4; 
        this._settings.scale.set( kSettingsScale );

        Session.i.room = [ Session.i.profile ];
        Session.i.gameType = game_type.MATCHMAKING;
        
        this._updateOtherPlayerSlots();

        ServiceLocator.multiplayerEventManager.onProfileChange.add( this._onProfile_Changed, this );
    }

        private _updateOtherPlayerSlots(): void
        {
            for ( let i: number = 1; i < Session.i.kGameRoomSize; ++i )
            {
                this._arrPlayerSlot[ i ].empty();
            }

            let myProfileIndex: number = 0;
            while ( Session.i.room[ myProfileIndex ].uid != Session.i.profile.uid )
            {
                myProfileIndex += 1;
            }
            
            switch ( myProfileIndex )
            {
                case 0:
                    {
                        if ( Session.i.room.length == 2 )
                        {
                            this._arrPlayerSlot[ 1 ].setPlayer( Session.i.room[ 1 ] );
                        }
                        else if ( Session.i.room.length == 3 )
                        {
                            this._arrPlayerSlot[ 1 ].setPlayer( Session.i.room[ 1 ] );
                            this._arrPlayerSlot[ 2 ].setPlayer( Session.i.room[ 2 ] );
                        }
                        else if ( Session.i.room.length == 4 )
                        {
                            this._arrPlayerSlot[ 1 ].setPlayer( Session.i.room[ 1 ] );
                            this._arrPlayerSlot[ 2 ].setPlayer( Session.i.room[ 2 ] );
                            this._arrPlayerSlot[ 3 ].setPlayer( Session.i.room[ 3 ] );
                        }
                        break;
                    }

                case 1:
                    {
                        if ( Session.i.room.length == 2 )
                        {
                            this._arrPlayerSlot[ 1 ].setPlayer( Session.i.room[ 0 ] );
                        }
                        else if ( Session.i.room.length == 3 )
                        {
                            this._arrPlayerSlot[ 1 ].setPlayer( Session.i.room[ 2 ] );
                            this._arrPlayerSlot[ 2 ].setPlayer( Session.i.room[ 0 ] );
                        }
                        else
                        {
                            this._arrPlayerSlot[ 1 ].setPlayer( Session.i.room[ 3 ] );
                            this._arrPlayerSlot[ 2 ].setPlayer( Session.i.room[ 0 ] );
                            this._arrPlayerSlot[ 3 ].setPlayer( Session.i.room[ 2 ] );
                        }
                        break;
                    }

                case 2:
                    {
                        if ( Session.i.room.length < 4 )
                        {
                            this._arrPlayerSlot[ 1 ].setPlayer( Session.i.room[ 0 ] );
                            this._arrPlayerSlot[ 2 ].setPlayer( Session.i.room[ 1 ] );
                        }
                        else
                        {
                            this._arrPlayerSlot[ 1 ].setPlayer( Session.i.room[ 0 ] );
                            this._arrPlayerSlot[ 2 ].setPlayer( Session.i.room[ 3 ] );
                            this._arrPlayerSlot[ 3 ].setPlayer( Session.i.room[ 1 ] );
                        }
                        break;
                    }

                case 3:
                    {
                        this._arrPlayerSlot[ 1 ].setPlayer( Session.i.room[ 2 ] );
                        this._arrPlayerSlot[ 2 ].setPlayer( Session.i.room[ 1 ] );
                        this._arrPlayerSlot[ 3 ].setPlayer( Session.i.room[ 0 ] );
                        break;
                    }
            }
        }

        private _onProfile_Changed( profile: Profile): void
        {
            Session.i.profile = profile;

            this._arrPlayerSlot[ 0 ].setPlayer( Session.i.profile )
        }

    public onLeave(): void
    {
        ServiceLocator.multiplayerEventManager.onProfileChange.remove( this._onProfile_Changed, this );

        if ( this._magnifyingGlassTween )
        {
            this._magnifyingGlassTween.kill();
            this._magnifyingGlassTween = null;
        }

        this._matchmakingReadyAnim.end();
        this._matchmakingReadyAnim = null;

        this._settings.end();
        this._settings = null;

        super.onLeave();
    }

    public onUpdate( dt: number ): void
    {
        if ( this._matchmakingReadyAnim.visible ) 
        { 
            this._matchmakingReadyAnim.update( dt );
            return; 
        }

        if ( Session.i.room.length > 0
            && Session.i.room.length <= Session.i.kGameRoomSize )
        {
            this._autoStartTimer += dt;
            if ( ( this._autoStartTimer > 1
                    && Session.i.room.length == 1 )
                || ( this._autoStartTimer > 3
                    && Session.i.room.length == 2 )
                || ( this._autoStartTimer > 4
                    && Session.i.room.length == 3 ) )
            {
                this._addBot();
                this._updateOtherPlayerSlots();
            }

            if ( this._autoStartTimer > 5 )
            {
                Session.i.prng = new PRNG( Math.floor( Math.random() * 9999 ) );

                if ( this._magnifyingGlassTween )
                {
                    this._magnifyingGlassTween.kill();
                    this._magnifyingGlassTween = null;
                }
                this._magnifyingGlass.visible = false;
                //
                this._headerText.visible = false;
                this._settings.visible = false;

                for ( let i: number = 0; i < Session.i.kGameRoomSize; ++i )
                {
                    if ( Session.i.room[ i ].isBot )
                    {
                        this._arrPlayerSlot[ i ].setPlayer( Session.i.room[ i ] );
                    }
                }

                let arrProfile: Array<Profile> = [];
                arrProfile.push( Session.i.room[ 0 ] );
                arrProfile.push( Session.i.room[ 1 ] );
                if ( Session.i.room.length == 4 )
                {
                    arrProfile.push( Session.i.room[ 3 ] );
                }
                arrProfile.push( Session.i.room[ 2 ] );

                for ( let i: number = 0; i < arrProfile.length; ++i )
                {
                    arrProfile[ i ].uid = i.toString();
                }
    
                Session.i.room = arrProfile;

                this._matchmakingReadyAnim.visible = true;
                let tl: gsap.core.Timeline = this._matchmakingReadyAnim.play();
                tl.call( () => { this._onCompleted.dispatch( screen_type.GAMEPLAY ); } );
            }
        }
    }

        private _addBot(): void
        {
            let profile: Profile = { 
                username: { prefix: this._arrBotNames[ Session.i.room.length - 1 ], suffix: Session.i.room.length.toString() },
                avatar: { src: "avatar_" + ( this._arrBotAvatarIndex[ Session.i.room.length - 1 ] ), alt: null } };
            profile.isBot = true;
            Session.i.room.push( profile );
        }

    // #endregion //
}

export interface IStartGamePayload
{
    seed: number,
    room: Array<Profile>
}